import { spawn } from "redux-saga/effects"

import loadDriftmeldingSaga from "./settings/driftmeldingSaga"
import infoBannerSaga from "./settings/infoBannerSaga"

export default function* () {
    yield spawn(loadDriftmeldingSaga)
    yield spawn(infoBannerSaga)
}
